<template>
  <div class="device-management">
    <div class="search-bar">
      <el-input
        v-model="searchQuery"
        placeholder="搜索设备名称或ID"
        prefix-icon="el-icon-search"
        clearable
      >
      </el-input>
    </div>
    <div class="device-grid">
      <div v-for="device in sortedAndFilteredDevices" :key="device.devid" class="device-card">
        <div class="device-image">
          <img :src="getDeviceImage(device)" :alt="device.devidName">
          <div class="status-indicator" :class="{ 'online': device.status === 'ON' }">
            {{ device.status === 'ON' ? '在线' : '离线' }}
          </div>
        </div>
        <div class="device-info">
          <h3>{{ device.devidName }}</h3>
          <p>HHBOX设备ID: {{ device.devid }}</p>
          <p>设备运行时间: {{ device.runTime || 0 }}分钟</p>
          <p>激光工作时间: {{ device.workTime || 0 }}分钟</p>
          <p>添加设备日期: {{ formatDate(device.createTime) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DeviceManagement',
  data() {
    return {
      devices: [],
      searchQuery: '',
      institutionName: localStorage.getItem('userInstitutionName').trim().replace(/^["']|["']$/g, '') || '',
      timer: null
    }
  },
  computed: {
    sortedAndFilteredDevices() {
      // 先过滤
      const filteredDevices = this.devices.filter(device => {
        if (!this.searchQuery) return true;
        const searchLower = this.searchQuery.toLowerCase();
        return (
          device.devidName.toLowerCase().includes(searchLower) ||
          device.devid.toLowerCase().includes(searchLower)
        );
      });

      // 再排序：在线设备优先
      return filteredDevices.sort((a, b) => {
        // 首先按在线状态排序
        if (a.status === 'ON' && b.status !== 'ON') return -1;
        if (a.status !== 'ON' && b.status === 'ON') return 1;
        
        // 如果在线状态相同，按创建时间降序排序
        return new Date(b.createTime) - new Date(a.createTime);
      });
    }
  },
  created() {
    this.fetchDevices();
    // 每秒刷新一次设备状态
    this.timer = setInterval(this.fetchDevices, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async fetchDevices() {
      try {
        const encodedInstitutionName = encodeURIComponent(this.institutionName);
        const response = await axios.get(`/api/devidTable/selectDevidByInstitutionName?institutionName=${encodedInstitutionName}`);
        if (response.data.code === 0) {
          this.devices = response.data.data;
        }
      } catch (error) {
        console.error('获取设备列表失败:', error);
      }
    },
    getDeviceImage(device) {
      // 根据设备名称选择对应的图片
      if (device.devidName.includes('530')) {
        return '/img/light-530.png';
      } else if (device.devidName.includes('640')) {
        return '/img/light-640.png';
      }else if (device.devidName.includes('1390')) {
        return '/img/light-1390.png';
      }else if (device.devidName.includes('960')) {
        return '/img/light-960.png';
      }else if (device.devidName.includes('打标机')) {
        return '/img/打标机.png';
      }else if (device.devidName.includes('蓝光')) {
        return '/img/蓝光激光切割机.png';
      }else if (device.devidName.includes('3D打印机')) {
        return '/img/3D打印机.png';
      }
      // 默认图片
      return '/img/light-530.png';
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    }
  }
}
</script>

<style scoped>
.device-management {
  padding: 20px;
  height: calc(100vh - 40px);
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: #ffffff;
  border-radius: 20px;
}

.device-management::-webkit-scrollbar {
  display: none;
}

.search-bar {
  margin-bottom: 20px;
  max-width: 400px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.device-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding-bottom: 80px;
}

.device-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s;
}

.device-card:hover {
  transform: translateY(-5px);
}

.device-image {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: #f5f5f5;
  padding: 10px;
}

.device-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.status-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 10px;
  border-radius: 15px;
  background: #ff4d4f;
  color: white;
  font-size: 12px;
}

.status-indicator.online {
  background: #52c41a;
}

.device-info {
  padding: 15px;
  text-align: justify;
}

.device-info h3 {
  margin: 0 0 10px;
  color: #1a1a1a;
}

.device-info p {
  margin: 5px 0;
  color: #333333;
  font-size: 14px;
}
</style>
